document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sub-accordion__toggle').forEach(toggle => {
    toggle.addEventListener('click', function () {
      const parent = this.closest('.sub-accordion');
      parent.classList.toggle('open');
    });
  });
});
